var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpretFraserIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.592,
    height: 55.726,
    viewBox: "0 0 61.592 55.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opret-fraser-ikon",
    transform: "translate(5002.477 -10203.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verified-document-2618577",
    transform: "translate(-4993.226 10204.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8393",
    "data-name": "Path 8393",
    d: "M148.956,85.986H132.9V38.4h30.43V57.463",
    transform: "translate(-118.477 -38.4)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8394",
    "data-name": "Path 8394",
    d: "M40.471,121.488l-12.234,3.389L16.3,81.719l7.928-2.4",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 1.815, -78.185)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x2: 4.193,
    transform: "translate(19.977 8.411)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 18.641,
    transform: "translate(19.977 13.495)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x2: 18.641,
    transform: "translate(19.977 18.579)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 18.641,
    transform: "translate(19.977 23.663)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 8.028,
    transform: "translate(19.977 38.915)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 4.193,
    transform: "translate(19.977 34.079)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil",
    "data-name": "Icon metro-pencil",
    d: "M20.882,1.928A3.391,3.391,0,0,1,23.6,7.354L22.239,8.71,17.491,3.963l1.356-1.356a3.376,3.376,0,0,1,2.035-.678ZM3.927,17.527l-1.356,6.1,6.1-1.356L21.221,9.727,16.474,4.98Zm13.81-7.893L8.242,19.129,7.073,17.96l9.495-9.495Z",
    transform: "translate(28.067 19.443)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8915",
    "data-name": "Path 8915",
    d: "M40.471,121.488l-12.234,3.389L16.3,81.719l9.037-2.734",
    transform: "translate(-28.599 -70.178) rotate(-3)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpretFraserIkon);
export default __webpack_public_path__ + "static/media/Opret-fraser-ikon.bdf0ef66bdfb2accb993398b84d63bae.svg";
export { ForwardRef as ReactComponent };